export default "__VITE_ASSET__B9evnZ3V__"